import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { INVESTOR_TEST_ELEMENT_ID } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Box, Text } from '@mantine/core';
import styled, { css } from 'styled-components';

interface ICardButton {
	className?: string;
	onClick?: () => void;
	showBank?: boolean;
	linkText?: string;
}

export const CardButton = styled(({ className, onClick, showBank, linkText }: ICardButton) => {
	const tInvestor = useTranslationInvestor();
	const text =
		linkText ??
		(!showBank
			? tInvestor('valuations.action_panel.start_workflow')
			: tInvestor('valuations.action_panel.get_banking_details'));
	return (
		<div
			className={className}
			onClick={onClick}
			onKeyDown={onClick}
			data-testid={INVESTOR_TEST_ELEMENT_ID.INVESTOR_GET_STARTED_BUTTON}
		>
			<Box data-testid={INVESTOR_TEST_ELEMENT_ID.INVESTOR_CARD_BUTTON_TEXT}>
				<Text size="B6Bold">{text}</Text>
			</Box>
			<Box data-testid={INVESTOR_TEST_ELEMENT_ID.INVESTOR_CARD_BUTTON_ARROW}>
				<Icon variant="arrow-right-v3" size="xl" />
			</Box>
		</div>
	);
})`
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: ${defaultTheme.v3.colors.dark[10]};
	background-color: ${defaultTheme.v3.colors.blue[4]};
	padding: 0.5rem;
	cursor: pointer;
	${({ showBank }) =>
		showBank &&
		css`
			color: ${defaultTheme.v3.colors.blue[4]};
			background-color: transparent;
			border-bottom: 1px solid ${defaultTheme.v3.colors.dark[4]};
		`};
`;
